export enum ROLES {
    STORE_OPERATOR = 'StoreOperator',
    EMPLOYEE = 'Employee',
    CASHIER = 'Cashier',
    ONLINE_SHOP_MANAGER = 'OnlineShopManager',
    SYSTEM_ADMINISTRATOR = 'SystemAdministrator',
    BRINGING_CUSTOMER = 'BringingCustomer',
    RETAIL_CUSTOMER = 'RetailCustomer',
}
